import './sass/frontend.scss';
import './add-to-cart-popup.js';
import './cart.js';
import './woocommerce.js';

import { select, subscribe } from '@wordpress/data';
import { cartStore } from '@woocommerce/block-data';
const { registerCheckoutFilters } = window.wc.blocksCheckout;

// Import the WordPress i18n module
const { __ } = wp.i18n;


const modifyShowApplyCouponNotice = (defaultValue, extensions, args) => {
    return false;
};

const modifyShowRemoveCouponNotice = (defaultValue, extensions, args) => {
    return false;
};

registerCheckoutFilters('fishouflage', {
    showApplyCouponNotice: modifyShowApplyCouponNotice,
    showRemoveCouponNotice: modifyShowRemoveCouponNotice,
});

// Ensure Astra variation button disabled state is correct on initial load and updates.
function syncAstraDisabledVariationButtons() {
    const variationSelectors = document.querySelectorAll('.ast-product-single-variable form .variations select');

    if (!variationSelectors.length) {
        return;
    }

    variationSelectors.forEach((select) => {
        const availableValues = [];
        const options = select.querySelectorAll('option');

        options.forEach((option) => {
            const value = option.getAttribute('value');
            if (value) {
                availableValues.push(value);
            }
        });

        const buttonGroup = select.previousElementSibling;
        const buttonList = buttonGroup ? buttonGroup.querySelectorAll('.ast-single-variation') : [];

        buttonList.forEach((button) => {
            const slug = button.getAttribute('data-slug');
            const isAvailable = slug && availableValues.includes(slug);

            button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
            button.setAttribute('tabindex', isAvailable ? '0' : '-1');
        });
    });
}

// Coupon form visibility management
function manageCouponFormVisibility() {
    // Check if we're on cart or checkout page
    if (!document.body.classList.contains('woocommerce-cart') &&
        !document.body.classList.contains('woocommerce-checkout')) {
        return;
    }

    // Function to check if any coupons are applied
    function hasCouponsApplied() {
        const { totals } = select(cartStore).getCartData();
        if (totals.total_discount > 0) {
            return true;
        }
        return false;
        // Check for applied coupons in various places
        const appliedCoupons = document.querySelectorAll(
            '.cart-discount, ' +                           // Standard cart discount rows
            '.woocommerce-remove-coupon, ' +              // Remove coupon links
            'tr.cart-discount, ' +                        // Table row cart discounts
            '.wc-block-components-totals-discount, ' +    // Checkout blocks discount
            '.wc-block-formatted-money-amount--discount, ' + // Checkout blocks discount amount
            '.wc-block-components-totals-coupon__content' // Checkout blocks applied coupon
        );

        // Also check if there's any text indicating applied coupons
        const couponTexts = document.querySelectorAll('[class*="coupon"], [class*="discount"]');
        let hasVisibleCoupons = false;

        couponTexts.forEach(element => {
            const text = element.textContent || '';
            if (text.toLowerCase().includes('remove') &&
                (text.toLowerCase().includes('coupon') || text.toLowerCase().includes('discount'))) {
                hasVisibleCoupons = true;
            }
        });

        const hasCoupons = appliedCoupons.length > 0 || hasVisibleCoupons;

        // Debug logging
        if (hasCoupons) {
            console.log('Fishouflage: Coupons detected, hiding coupon forms');
        } else {
            console.log('Fishouflage: No coupons detected, showing coupon forms');
        }

        return hasCoupons;
    }

    // Function to hide/show coupon forms
    function toggleCouponForms() {
        const hasCoupons = hasCouponsApplied();

        // Standard WooCommerce coupon forms
        const couponForms = document.querySelectorAll(
            '.coupon, ' +                                    // Cart page coupon form
            '.checkout_coupon, ' +                           // Checkout page coupon form
            '.woocommerce-form-coupon, ' +                   // General coupon forms
            '#ast-checkout-coupon, ' +                       // Astra modern coupon
            '.wfacp_woocommerce_form_coupon, ' +            // FunnelKit checkout forms
            '.woocommerce-form-coupon-toggle, ' +           // Coupon toggle forms
            '.wp-block-woocommerce-checkout-order-summary-coupon-form-block, ' + // Checkout blocks coupon form
            '.wc-block-components-totals-coupon, ' +        // Checkout blocks coupon component
            '.wc-block-checkout__add-coupon, ' +            // Checkout blocks add coupon section
            '.wc-block-components-panel'                    // Checkout blocks coupon panel
        );

        const couponTriggers = document.querySelectorAll(
            '.showcoupon, ' +                               // Standard checkout coupon trigger
            '.wfacp_showcoupon, ' +                        // FunnelKit coupon trigger
            '.wfacp_main_showcoupon, ' +                   // FunnelKit main coupon trigger  
            '#ast-coupon-trigger, ' +                      // Astra coupon trigger
            '.wc-block-components-totals-coupon__button, ' + // Checkout blocks coupon button
            '.wc-block-checkout__add-coupon-button'        // Checkout blocks add coupon button
        );

        // Debug logging to see what elements are found
        if (couponForms.length > 0) {
            //console.log('Fishouflage: Found coupon forms:', couponForms);
        }
        if (couponTriggers.length > 0) {
            //console.log('Fishouflage: Found coupon triggers:', couponTriggers);
        }

        couponForms.forEach(form => {
            if (hasCoupons) {
                form.style.display = 'none';
            } else {
                form.style.display = '';
            }
        });

        couponTriggers.forEach(trigger => {
            if (hasCoupons) {
                trigger.style.display = 'none';
            } else {
                trigger.style.display = '';
            }
        });
    }

    // Initial check when page loads
    toggleCouponForms();

    // Listen for cart updates (when coupons are applied/removed)
    jQuery(document.body).on('updated_cart_totals', toggleCouponForms);
    jQuery(document.body).on('update_checkout', toggleCouponForms);
    jQuery(document.body).on('applied_coupon', toggleCouponForms);
    jQuery(document.body).on('removed_coupon', toggleCouponForms);

    // Listen for AJAX cart updates
    jQuery(document.body).on('wc_fragment_refresh', toggleCouponForms);
    jQuery(document.body).on('wc_fragments_refreshed', toggleCouponForms);

    // Listen for FunnelKit specific events if present
    if (typeof wfacp_frontend !== 'undefined') {
        jQuery(document.body).on('wfacp_coupon_apply', toggleCouponForms);
        jQuery(document.body).on('wfacp_coupon_form_removed', toggleCouponForms);
    }

    // Listen for checkout blocks specific events
    if (typeof wp !== 'undefined' && wp.hooks) {
        // Listen for checkout blocks data changes
        wp.hooks.addAction('experimental__woocommerce_blocks-checkout-render-checkout-form', 'fishouflage', toggleCouponForms);
        wp.hooks.addAction('experimental__woocommerce_blocks-checkout-set-email-address', 'fishouflage', toggleCouponForms);
    }

    // Additional checkout blocks event listeners
    document.addEventListener('wc-blocks_checkout_totals_changed', toggleCouponForms);
    document.addEventListener('wc-blocks_added_to_cart', toggleCouponForms);

    // Use MutationObserver to watch for DOM changes in cart totals
    const cartTotalsObserver = new MutationObserver(function (mutations) {
        let shouldCheck = false;
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
                // Check if any cart discount rows were added or removed
                const addedNodes = Array.from(mutation.addedNodes);
                const removedNodes = Array.from(mutation.removedNodes);

                addedNodes.concat(removedNodes).forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.classList && (
                            node.classList.contains('cart-discount') ||
                            node.classList.contains('woocommerce-remove-coupon') ||
                            node.classList.contains('wc-block-components-totals-discount') ||
                            node.classList.contains('wc-block-components-totals-coupon__content') ||
                            (node.querySelector && node.querySelector(
                                '.cart-discount, .woocommerce-remove-coupon, ' +
                                '.wc-block-components-totals-discount, ' +
                                '.wc-block-components-totals-coupon__content'
                            ))
                        )) {
                            shouldCheck = true;
                        }
                    }
                });
            }
        });

        if (shouldCheck) {
            setTimeout(toggleCouponForms, 100); // Small delay to ensure DOM is fully updated
        }
    });

    // Start observing cart totals sections
    const cartTotalsElements = document.querySelectorAll(
        '.cart_totals, ' +
        '.woocommerce-checkout-review-order-table, ' +
        '.shop_table, ' +
        '.wc-block-components-totals-wrapper, ' +     // Checkout blocks totals
        '.wc-block-checkout__totals, ' +              // Checkout blocks totals container
        '.wp-block-woocommerce-checkout-order-summary-block' // Checkout blocks order summary
    );
    cartTotalsElements.forEach(element => {
        cartTotalsObserver.observe(element, {
            childList: true,
            subtree: true
        });
    });
}
const unsubscribe = subscribe(() => {

    manageCouponFormVisibility();

}, cartStore);

document.addEventListener("DOMContentLoaded", function () {
    // Initial sync after Woo/Astra variation form setup.
    setTimeout(syncAstraDisabledVariationButtons, 150);

    // Re-sync whenever variation values are recalculated.
    jQuery(document).on(
        'wc_variation_form woocommerce_update_variation_values woocommerce_variation_has_changed found_variation reset_data',
        '.variations_form',
        function () {
            setTimeout(syncAstraDisabledVariationButtons, 0);
        }
    );

    // Initialize coupon form management
    manageCouponFormVisibility();

    // Mobile menu: first tap on parent link opens submenu; second tap navigates
    // Expose as global so we can re-initialize when the mobile menu is toggled
    window.fishouflageEnableMobileMenuParentLinkToggle = function () {
        const parentLinks = document.querySelectorAll('.main-header-menu .menu-item-has-children > a');

        if (!parentLinks || parentLinks.length === 0) {
            return;
        }


        parentLinks.forEach(link => {
            // Avoid duplicate bindings
            if (link.dataset.ffBound === '1') {
                return;
            }
            link.dataset.ffBound = '1';


            link.addEventListener('click', function (e) {

                const parentLi = this.closest('.menu-item-has-children');
                if (!parentLi) {
                    return;
                }
                // Prevent Astra's global handlers from closing the menu.
                e.preventDefault();
                e.stopPropagation();
                if (typeof e.stopImmediatePropagation === 'function') {
                    e.stopImmediatePropagation();
                }
                const toggle = parentLi.querySelector('.ast-menu-toggle');
                if (toggle) {
                    toggle.click();
                }
            });

            link.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') {
                    this.click();
                }
            });
        });
    };

    // Initial bind
    if (window.matchMedia('(max-width: 768px)').matches) {
        window.fishouflageEnableMobileMenuParentLinkToggle();
    }

    // Re-bind whenever the mobile hamburger is toggled (Astra adds this button)
    document.querySelectorAll('.main-header-menu-toggle').forEach(btn => {
        btn.addEventListener('click', () => {
            // Delay to allow menu DOM to render
            setTimeout(() => window.fishouflageEnableMobileMenuParentLinkToggle(), 50);
        });
    });
});

// Define our filter callback.
function fishouflageGettextFilter(translation, text, domain) {

    if (text === 'Add coupons') {
        return 'Add a Promo Code';
    }
    if (text === 'Enter code') {
        return 'Enter Promo Code';
    }
    if (text === 'Create an account with %s') {
        translation = 'Create an Account (Add a password to track/lookup your orders online)';
    }
    if (text === 'Product') {
        translation = 'Item';
    }
    return translation;
}

// Adding the filter
wp.hooks.addFilter(
    'i18n.gettext_woocommerce',
    'fishouflage/override-woo-text',
    fishouflageGettextFilter
);
